// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".leaflet-map[data-v-85a7027a]{height:550px;width:100%;z-index:1}.leaflet-map .map-popup[data-v-85a7027a]{font-family:var(--font-family-sans-serif)}@media(min-width:992px){.leaflet-map .map-popup .map-popup-block[data-v-85a7027a]{width:350px}}@media(max-width:991.98px){.leaflet-map .map-popup .map-popup-block[data-v-85a7027a]{max-width:80vw;width:315px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
